import React from 'react';
import AppContainer from '../app-container';
import * as stageActions from '../../actions/stages';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import LocalizedStrings from '../../localization/strings';
import DataTable from '../../components/data-table/data-table';
import DistanceFilter from '../../components/filters/distance-filter';
import DocumentTitle from 'react-document-title';
import {browserHistory} from 'react-router';

class StageParticipantsPageContainer extends AppContainer {

    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            query: '',
            distance: null
        };
    }

    componentWillMount() {
        this.props.actions.fetchStage(this.props.params.itemId).then(this.handlePageResult.bind(this));
        this.fetch({})
    }

    fetch(params) {
        const fetchParams = {
            ...this.state,
            ...params
        }
        this.setState(fetchParams);
        this.props.actions.fetchStageParticipants(this.props.params.itemId, fetchParams.page, fetchParams.size, {
            query: fetchParams.query,
            participantType: window.CARE_CONFIG.onlyPayedParticipants ? 'payed': 'all',
            distance: fetchParams.distance
                ? fetchParams.distance.value
                : ''
        });
    }
    handleQueryChange(event) {
        this.setState({value: event.target.value, page: 0});
        this.fetch({query: event.target.value, page: 0});
    }

    onChangeDistance(distance) {
        if (distance && !distance.value) {
            distance = null;
        }
        this.fetch({distance, page: 0});
    }

    onParticipantClick(item) {
        browserHistory.push(`/participant/${item.uuid}`);
    }

    render() {
        var config = {
            cols: [
                {
                    value: 'displayName',
                    header: `${LocalizedStrings.firstName} ${LocalizedStrings.lastName}`
                }, {
                    value: (item) => {
                        return item.distance
                            ? item.distance.name
                            : ''
                    },
                    header: LocalizedStrings.distance
                }, {
                    value: (item) => {
                        if (item.payed) {
                            return LocalizedStrings.yes;
                        }
                        return LocalizedStrings.no;
                    },
                    header: LocalizedStrings.payed
                }, {
                    value: 'club',
                    header: LocalizedStrings.club

                }, {
                    value: 'city',
                    header: LocalizedStrings.city
                }

            ]
        };
        const {stage, stageParticipants} = this.props;
        return (
            <DocumentTitle title={this.getDocumentTitle(LocalizedStrings.participants)}>

                <div className="page-section">
                    <div className="container">
                        <h1 className="title">
                            <span>{stage.item.name}
                            </span>
                        </h1>
                        <h3 className="title">
                            <span>{LocalizedStrings.participants}
                            </span>
                        </h3>
                        <div className="filters">
                            <form>
                                <div className="inline-fields">
                                    <div className="form-row">
                                        <div className="form-field">
                                            <div className="field-control">
                                                <input type="text" value={this.state.query} onChange={this.handleQueryChange.bind(this)} placeholder={LocalizedStrings.search}/>
                                            </div>
                                        </div>
                                        <div className="form-field">
                                            <div className="field-control">
                                                {stage.loading
                                                    ? null
                                                    : <DistanceFilter distances={stage.item.distances} onChange={this.onChangeDistance.bind(this)} value={this.state.distance}></DistanceFilter>}
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </form>
                        </div>


                        <DataTable config={config} loading={stageParticipants.loading} items={stageParticipants.items} page={stageParticipants.page} total={stageParticipants.total} totalPages={stageParticipants.total_pages} loadAction={this.fetch.bind(this)} className="participants-table" responsive={false} clickable={this.onParticipantClick.bind(this)}></DataTable>
                        <div className="strong m-top-10">
                            {LocalizedStrings.totalParticipants}: {stageParticipants.total}
                        </div>
                    </div>
                </div>
            </DocumentTitle>
        )

    }
}
export default connect(function(state) {
    return {stage: state.stage.stage, stageParticipants: state.stage.stageParticipants};
}, function(dispatch) {
    return {
        actions: bindActionCreators({
            ...stageActions
        }, dispatch)
    };
})(StageParticipantsPageContainer);



// WEBPACK FOOTER //
// ./src/js/containers/pages/stage-participants-page-container.js